import React from 'react';
import { string, node, func, bool } from 'prop-types';
import classNames from 'classnames';
import Title from '../../../../shared_modules/rc-title';
import { ButtonGroup } from '../../../../shared_modules/local-propulsion/components';
import Header from '../../../../shared_modules/rc-header';
import { SECONDS_TEXT } from '../../utils/constants';
import { Disclaimer, JointFaq } from '../../components';
import { NotificationBanner } from '@shared_modules/local-propulsion/components';
import clockIcon from '@shared_modules/common-images/clock.svg';

const getSinglePageDisclaimerText = loanType =>
  loanType === 'joint'
    ? "Checking your rate won't impact any of the applicants' credit scores.*"
    : "Checking your rate won't impact your credit score.*";

const Page = props => {
  return (
    <>
      <div className={`page page--${props.name} ${props.additionalClasses}`}>
        <div
          className={classNames('page__container', {
            'page__container--right-rails': props.rightRailsContent,
          })}
        >
          {props.showNotificationBanner && (
            <div className="page__banner">
              <NotificationBanner icon={clockIcon} className="completeBanner" message={SECONDS_TEXT} />
            </div>
          )}
          {!!props.title && (
            <div className="page__title">
              <Title>{props.title}</Title>
            </div>
          )}
          <div className={`page__header ${props.header ? '' : 'page__header--hidden'}`}>
            <Header className={props.headerClassName}>{props.header}</Header>
          </div>
          <div className="page__content">
            <form name={props.name} className="page__form" onSubmit={props.submitHandler}>
              <div
                className={classNames(`page__form-inputs ${props.contentClassName}`, {
                  'page__form-inputs--with-btn-subtext': props.subText,
                  'page__form-inputs--security-notice': props.securityNotice,
                  'page__form-inputs--loanTypePage': props.isLoanTypePage,
                })}
              >
                {props.children}
                {props.showJointFaq && <JointFaq showPatriotActDisclosures={props.showPatriotActDisclosures} />}
              </div>
              {props.showButtonGroup && (
                <div className={`page__button-group${props.isLoanTypePage ? '--loanTypePage' : ''}`}>
                  {props.securityNotice}
                  <ButtonGroup
                    goBack={props.goBack}
                    disableSubmit={props.disableSubmit}
                    subText={props.subText}
                    submitLabel={props.submitLabel}
                    submitBtnClassName={props.submitBtnClassName}
                    btnGroupClassName={props.btnGroupClassName}
                    name={props.name}
                  />
                  {props.showSingleDisclaimer && (
                    <p className="page__singleDisclaimer">{getSinglePageDisclaimerText(props.loanType)}</p>
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
        {props.rightRailsContent && <div className="page__right-rails">{props.rightRailsContent}</div>}
      </div>
      {props.showDisclaimerContent && (
        <div className={`page__${props.isLoanTypePage ? 'loanTypePageDisclaimer' : 'disclaimer'}`}>
          <div
            className={`page__${props.isLoanTypePage ? 'loanTypePageDisclaimer__container' : 'disclaimer__container'}`}
          >
            <Disclaimer hideMargin={props.showPatriotActDisclosures} />
          </div>
        </div>
      )}
    </>
  );
};

Page.propTypes = {
  title: node,
  header: node,
  children: node,
  securityNotice: node,
  name: string.isRequired,
  goBack: func,
  submitHandler: func.isRequired,
  disableSubmit: bool,
  subText: string,
  submitLabel: string,
  submitBtnClassName: string,
  headerClassName: string,
  contentClassName: string,
  rightRailsContent: node,
  showDisclaimerContent: bool,
  btnGroupClassName: string,
  showPatriotActDisclosures: bool,
  showButtonGroup: bool,
  showJointFaq: bool,
  additionalClasses: string,
  isLoanTypePage: bool,
  showSingleDisclaimer: bool,
  loanType: string,
  showNotificationBanner: bool,
};

Page.defaultProps = {
  title: undefined,
  header: undefined,
  children: undefined,
  securityNotice: undefined,
  goBack: undefined,
  disableSubmit: false,
  subText: '',
  submitLabel: 'Next',
  submitBtnClassName: '',
  headerClassName: '',
  contentClassName: '',
  rightRailsContent: undefined,
  showDisclaimerContent: false,
  btnGroupClassName: '',
  showButtonGroup: true,
  showPatriotActDisclosures: false,
  showJointFaq: false,
  additionalClasses: '',
  isLoanTypePage: false,
  showSingleDisclaimer: false,
  loanType: '',
  showNotificationBanner: false,
};

export default Page;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/Page/Page.scss');